import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import Login from "../components/Login/Login";

function LoginLayout() {
  const admin = useSelector((state) => state.admin);
  function adminLogged() {
    return Object.entries(admin).length;
  }

  return <>{!adminLogged() ? <Login /> : <Redirect to="/admin/dashboard" />}</>;
}

export default LoginLayout;
